// extracted by mini-css-extract-plugin
export default {"balance_table":"BalanceTable_balance_table__ydUG7","accession_label":"BalanceTable_accession_label__Osm+G"};